module.exports = __webpack_public_path__ + "img/PGR_A01_front_en.439051ea.png";